import { render, staticRenderFns } from "./BondGiveBackListForm.vue?vue&type=template&id=70fd2345"
import script from "./BondGiveBackListForm.vue?vue&type=script&lang=js"
export * from "./BondGiveBackListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports